import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  max-width: 410px;\n\n  &:hover {\n    .tooltip {\n      display: flex;\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n      @media (max-width: 1200px) {\n        display: none;\n      }\n    }\n  }\n\n  .tooltip {\n    z-index: 1;\n    transition: all 0.3s ease;\n    transform: scale(0.8);\n    opacity: 0;\n    max-width: 410px;\n    position: absolute;\n    box-shadow: 6px 6px 20px 0px rgba(28, 31, 46, 0.12);\n    visibility: hidden;\n    top: -150px;\n    left: 0;\n    white-space: nowrap;\n    padding: 20px;\n    border-radius: 4px;\n    background: #ffff;\n\n    > div {\n      display: flex;\n      font-size: 14px;\n      color: #4f556b;\n      width: 400px;\n      word-wrap: break-word;\n      white-space: normal;\n      flex-wrap: wrap;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 100%;\n      left: 42px;\n      margin-left: -8px;\n      border-width: 8px;\n      border-style: solid;\n      border-color: #ffff transparent transparent transparent;\n    }\n    .tooltip-message {\n      @media (max-width: 1200px) {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { useTheme } from "styled-components";
import { useCallback, useEffect, useRef, useState } from "react";
import Icon from "@/components/icon/Icon";
import { InfoCircle, QuestionCircle } from "@/components/icon/IconList";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
export const TooltipWithIcon = (param)=>{
    let { icon , message , color , size , children , link , isHover  } = param;
    const theme = useTheme();
    const isMobile = useWindowDimensions().width < 1200;
    const renderIcon = useCallback(()=>{
        switch(icon){
            case "question":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: QuestionCircle,
                    size: size,
                    color: color
                });
            case "info":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: InfoCircle,
                    size: size,
                    color: color
                });
            default:
                return null;
        }
    }, [
        icon
    ]);
    const tooltipRef = useRef(null);
    const [tooltipTop, setTooltipTop] = useState(150);
    const [isHovered, setIsHovered] = useState(false);
    useEffect(()=>{
        if (tooltipRef.current) {
            const tooltipHeight = tooltipRef.current.clientHeight + 16;
            setTooltipTop(tooltipHeight);
        }
    }, [
        message,
        isHovered
    ]);
    return /*#__PURE__*/ _jsxs(Tooltip, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                className: "tooltip",
                style: {
                    color: color,
                    top: -tooltipTop
                },
                ref: tooltipRef,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "tooltip-message",
                    children: message
                })
            }),
            /*#__PURE__*/ _jsx(_Fragment, {
                children: children
            }),
            !!icon && /*#__PURE__*/ _jsx("span", {
                children: renderIcon()
            })
        ]
    });
};
const Tooltip = styled.div.withConfig({
    componentId: "sc-aa3fe966-0"
})(_templateObject());
